function showAllSwatches(button) {
  // Find the parent swatch container that contains the "+" button
  const parentSwatchContainer = button.closest('.product_swatch');

  // Show all hidden swatches within this container
  const hiddenSwatches = parentSwatchContainer.querySelectorAll('.hidden');
  hiddenSwatches.forEach(swatch => {
    swatch.classList.remove('hidden');
  });

  // Add the 'visible' class to the corresponding '.featured_product_product'
  const featuredProductContainer = parentSwatchContainer.closest('.featured_product_product');
  if (featuredProductContainer) {
    featuredProductContainer.classList.add('visible');
  }

  // Remove the "+" button after it's clicked
  button.remove();
}

document.addEventListener("DOMContentLoaded", function () {
  const featuredProducts = document.querySelectorAll(".featured_product_product");

  featuredProducts.forEach((product) => {
    const swatches = product.querySelectorAll(".swatch-item");
    const productImage = product.querySelector(".product_image img");
    const quantityInput = product.querySelector(".quantity-field");
    const addButton = product.querySelector(".add-to-cart-form");
    const variantInput = addButton.querySelector(".variant-id");
    const quantityInputField = addButton.querySelector(".quantity-input");

    // Ensure the first swatch is selected by default
    if (swatches.length > 0) {
      const firstSwatch = swatches[0];
      const firstVariantId = firstSwatch.getAttribute("data-variant-id");
      const firstImage = firstSwatch.getAttribute("data-image");

      // Set the default variant ID and image
      variantInput.value = firstVariantId;
      if (firstImage) {
        productImage.src = firstImage;
      }

      // Highlight the first swatch (optional, for visual indication)
      firstSwatch.classList.add("selected");

      // Handle swatch click
      swatches.forEach((swatch) => {
        swatch.addEventListener("click", function () {
          // Remove the "selected" class from all swatches
          swatches.forEach(s => s.classList.remove("selected"));

          // Add the "selected" class to the clicked swatch
          swatch.classList.add("selected");

          // Update selected variant ID
          const selectedVariantId = swatch.getAttribute("data-variant-id");

          // Update variant input value
          variantInput.value = selectedVariantId;

          // Change image based on selected swatch
          const newImage = swatch.getAttribute("data-image");
          if (newImage) {
            productImage.src = newImage;
          }
        });
      });
    }

    // Handle quantity change (using buttons)
    const updateQuantity = (increment) => {
      let quantity = parseInt(quantityInput.value);
      if (increment) {
        quantity++;
      } else {
        quantity = quantity > 1 ? quantity - 1 : 1;
      }
      quantityInput.value = quantity;
      quantityInputField.value = quantity;
    };

    product.querySelector(".button-plus").addEventListener("click", function () {
      updateQuantity(true);
    });

    product.querySelector(".button-minus").addEventListener("click", function () {
      updateQuantity(false);
    });

    // Set initial quantity
    quantityInputField.value = quantityInput.value;

    // Handle the add-to-cart form submission
    addButton.addEventListener("submit", function (e) {
      e.preventDefault();

      // Ensure the variant ID and quantity are updated before submission
      variantInput.value = variantInput.value || swatches[0].getAttribute("data-variant-id");
      quantityInputField.value = quantityInput.value;

      // Submit the form using fetch to prevent page redirection
      fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          id: variantInput.value,
          quantity: quantityInputField.value,
        }),
      })
      .then((response) => response.json())
      .then(() => {
        // Open the cart drawer after adding the product
        document.querySelector('body').classList.add('cart-drawer-open');
      })
      .catch((error) => console.error("Error adding to cart:", error));
    });
  });
});